// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import BootstrapVue from 'bootstrap-vue'
import VueYouTubeEmbed from 'vue-youtube-embed'

import VueFacebookPixel from 'vue-analytics-facebook-pixel' 
Vue.use(VueFacebookPixel)

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-113126258-1'
})


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
var VueScrollTo = require('vue-scrollto');

Vue.use(BootstrapVue);

Vue.use(VueScrollTo)
Vue.use(VueYouTubeEmbed)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
}
)




// WEBPACK FOOTER //
// ./src/main.js